var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin pta-callcenter" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-20",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm.investor_callcenter.total
              ? _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-body",
                      staticStyle: { padding: "20px" },
                    },
                    [
                      _vm.hasPermission("list-user") &&
                      _vm.investor_callcenter.total
                        ? _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              {
                                staticClass: "table table-hover",
                                class: _vm.selected_entry ? "pta-editmode" : "",
                                staticStyle: { "margin-bottom": "0" },
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Name"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Job title"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Organisation"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Phone Work"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Phone Org"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v("Campaign"),
                                    ]),
                                    _vm._v(" "),
                                    _vm.selected_entry
                                      ? _c(
                                          "th",
                                          {
                                            attrs: {
                                              scope: "col",
                                              width: "170",
                                            },
                                          },
                                          [_vm._v("Status")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selected_entry
                                      ? _c(
                                          "th",
                                          {
                                            attrs: {
                                              scope: "col",
                                              width: "224",
                                            },
                                          },
                                          [_vm._v("Result")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selected_entry
                                      ? _c(
                                          "th",
                                          {
                                            attrs: {
                                              scope: "col",
                                              width: "150",
                                            },
                                          },
                                          [_vm._v("Phone New")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selected_entry
                                      ? _c(
                                          "th",
                                          {
                                            attrs: {
                                              scope: "col",
                                              width: "424",
                                            },
                                          },
                                          [_vm._v("Notes")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "table-option",
                                        staticStyle: { width: "100px" },
                                        attrs: { scope: "col", width: "100" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.trans("general.action"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.investor_callcenter.data,
                                    function (investor_callcenter_entry) {
                                      return _c(
                                        "tr",
                                        {
                                          class:
                                            _vm.selected_entry ==
                                            investor_callcenter_entry.id
                                              ? "pta-active"
                                              : "",
                                          staticStyle: { cursor: "pointer" },
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.selected_entry ==
                                                  investor_callcenter_entry.id
                                                    ? _vm.resetCallcenterEntryForm()
                                                    : _vm.setCallcenterEntryForm(
                                                        investor_callcenter_entry
                                                      )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    investor_callcenter_entry
                                                      .investor_contact
                                                      .first_name +
                                                      " " +
                                                      investor_callcenter_entry
                                                        .investor_contact
                                                        .last_name
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.selected_entry ==
                                                  investor_callcenter_entry.id
                                                    ? _vm.resetCallcenterEntryForm()
                                                    : _vm.setCallcenterEntryForm(
                                                        investor_callcenter_entry
                                                      )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    investor_callcenter_entry
                                                      .investor_contact
                                                      .job_title
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          investor_callcenter_entry
                                            .investor_contact.investor
                                            ? _c(
                                                "td",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.selected_entry ==
                                                      investor_callcenter_entry.id
                                                        ? _vm.resetCallcenterEntryForm()
                                                        : _vm.setCallcenterEntryForm(
                                                            investor_callcenter_entry
                                                          )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        investor_callcenter_entry
                                                          .investor_contact
                                                          .investor.name
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.selected_entry ==
                                                      investor_callcenter_entry.id
                                                        ? _vm.resetCallcenterEntryForm()
                                                        : _vm.setCallcenterEntryForm(
                                                            investor_callcenter_entry
                                                          )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    -\n                  "
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "pta-phonenumbers" },
                                            _vm._l(
                                              investor_callcenter_entry
                                                .investor_contact.phone_work,
                                              function (phone) {
                                                return _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "tel:" + phone,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(phone))]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "pta-phonenumbers" },
                                            _vm._l(
                                              investor_callcenter_entry
                                                .investor_contact.phone_org,
                                              function (phone) {
                                                return _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "pta-phonenumber-org",
                                                    attrs: {
                                                      href: "tel:" + phone,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(phone))]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.selected_entry ==
                                                  investor_callcenter_entry.id
                                                    ? _vm.resetCallcenterEntryForm()
                                                    : _vm.setCallcenterEntryForm(
                                                        investor_callcenter_entry
                                                      )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    investor_callcenter_entry.campaign
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.selected_entry
                                            ? _c("td", [
                                                _vm.selected_entry ==
                                                investor_callcenter_entry.id
                                                  ? _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .callcenterEntryForm
                                                                .status,
                                                            expression:
                                                              "callcenterEntryForm.status",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.$set(
                                                              _vm.callcenterEntryForm,
                                                              "status",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "",
                                                            },
                                                          },
                                                          [_vm._v("None")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "1",
                                                            },
                                                          },
                                                          [_vm._v("Spoken")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "2",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Not Reached"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "3",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Left Voicemail"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "4",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Invalid Number"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "5",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Requested Call back"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "6",
                                                            },
                                                          },
                                                          [_vm._v("Blocker")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selected_entry
                                            ? _c("td", [
                                                _vm.selected_entry ==
                                                  investor_callcenter_entry.id &&
                                                _vm.callcenterEntryForm
                                                  .status == 1
                                                  ? _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .callcenterEntryForm
                                                                .result,
                                                            expression:
                                                              "callcenterEntryForm.result",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        staticStyle: {
                                                          width: "200px",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.$set(
                                                              _vm.callcenterEntryForm,
                                                              "result",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "",
                                                            },
                                                          },
                                                          [_vm._v("None")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "1",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Interested, Added to Deal Section and Dates Provided"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "2",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Interested, More Information Requested and Added to Deals Section"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "3",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Not Interested"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "4",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Do not again"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "5",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Not Investing in the Next 12 Months"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "6",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Investing in the Next 12 Months"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.callcenterEntryForm
                                                  .result == 1 ||
                                                _vm.callcenterEntryForm
                                                  .result == 2
                                                  ? _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .callcenterEntryForm
                                                                .client_id,
                                                            expression:
                                                              "callcenterEntryForm.client_id",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        staticStyle: {
                                                          width: "200px",
                                                          "margin-top": "5px",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.$set(
                                                              _vm.callcenterEntryForm,
                                                              "client_id",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        !_vm.callcenterEntryForm
                                                          .client_id
                                                          ? _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  value: "0",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Please choose campaign"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.clients.data,
                                                          function (client) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                domProps: {
                                                                  value:
                                                                    client.id,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    client
                                                                      .profile
                                                                      .company
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selected_entry
                                            ? _c("td", [
                                                _vm.selected_entry ==
                                                investor_callcenter_entry.id
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .callcenterEntryForm
                                                              .phone_new,
                                                          expression:
                                                            "callcenterEntryForm.phone_new",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        value: "",
                                                        name: "phone_new",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm
                                                            .callcenterEntryForm
                                                            .phone_new,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.callcenterEntryForm,
                                                            "phone_new",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selected_entry
                                            ? _c("td", [
                                                _vm.selected_entry ==
                                                investor_callcenter_entry.id
                                                  ? _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .callcenterEntryForm
                                                              .notes,
                                                          expression:
                                                            "callcenterEntryForm.notes",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      staticStyle: {
                                                        width: "400px",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm
                                                            .callcenterEntryForm
                                                            .notes,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.callcenterEntryForm,
                                                            "notes",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "table-option" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "btn-group" },
                                                [
                                                  _vm.selected_entry !=
                                                  investor_callcenter_entry.id
                                                    ? _c(
                                                        "button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value: _vm.trans(
                                                                "investor_callcenter.edit_entry"
                                                              ),
                                                              expression:
                                                                "trans('investor_callcenter.edit_entry')",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "btn btn-info btn-sm",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.setCallcenterEntryForm(
                                                                investor_callcenter_entry
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-edit",
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.selected_entry ==
                                                  investor_callcenter_entry.id
                                                    ? _c(
                                                        "button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value: _vm.trans(
                                                                "investor_callcenter.cancel"
                                                              ),
                                                              expression:
                                                                "trans('investor_callcenter.cancel')",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "btn btn-info btn-sm",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.resetCallcenterEntryForm()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-cancel",
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.selected_entry ==
                                                  investor_callcenter_entry.id
                                                    ? _c(
                                                        "button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value: _vm.trans(
                                                                "investor_callcenter.save_entry"
                                                              ),
                                                              expression:
                                                                "trans('investor_callcenter.save_entry')",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "btn btn-info btn-sm",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.submit()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-save",
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ])
              : _c("div", [_vm._v("No entries available.")]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-titles border-bottom" }, [
      _c("h3", [_vm._v("Limited Partners // Callcenter")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }